export const STARTING_LOCATIONS = {
  home: '', // Home address loaded dynamically from user settings
  office: '' // Office address loaded dynamically from company settings
};

export const LOCATION_DISTANCES = {
  '15 Maple Avenue, River City, R34 5GH': {
    '22 Oak Street, River City, R34 6TY': 3.2,
    '8 Pine Road, River City, R34 8UY': 4.5
  },
  '22 Oak Street, River City, R34 6TY': {
    '8 Pine Road, River City, R34 8UY': 2.8
  }
};

export const STARTING_DISTANCES = {
  home: {
    '15 Maple Avenue, River City, R34 5GH': 5.2,
    '22 Oak Street, River City, R34 6TY': 4.8,
    '8 Pine Road, River City, R34 8UY': 6.1
  },
  office: {
    '15 Maple Avenue, River City, R34 5GH': 3.8,
    '22 Oak Street, River City, R34 6TY': 5.6,
    '8 Pine Road, River City, R34 8UY': 4.2
  }
};

export const EVENT_TYPE_COLORS: Record<string, string> = {
  'On-Site Estimate': 'bg-blue-100 text-blue-700 border-blue-200',
  'Repair Service': 'bg-red-100 text-red-700 border-red-200',
  'Maintenance Check': 'bg-green-100 text-green-700 border-green-200',
  'Installation': 'bg-blue-100 text-blue-700 border-blue-200',
  'Consultation': 'bg-orange-100 text-orange-700 border-orange-200',
  'Inspection': 'bg-yellow-100 text-yellow-700 border-yellow-200',
  'Emergency Service': 'bg-pink-100 text-pink-700 border-pink-200',
  'Follow-up Visit': 'bg-blue-100 text-blue-700 border-blue-200'
};

export const BOOKING_FORM_EVENT_COLORS: Record<string, { bg: string; border: string; text: string }> = {
  lavender: { bg: '#E9E4F5', border: '#A78BDA', text: '#5B3D87' },
  mint: { bg: '#D5F5E3', border: '#5DBEA3', text: '#1D6F52' },
  peach: { bg: '#FCE5D8', border: '#E8956A', text: '#8B4B2B' },
  sky: { bg: '#DBF0FE', border: '#6BB8F0', text: '#1E5F8C' },
  rose: { bg: '#FCE4EC', border: '#E57FAD', text: '#8E2D5B' },
  lemon: { bg: '#FFF9DB', border: '#E6C75A', text: '#7A6420' },
  sage: { bg: '#E8F0E6', border: '#7DB07A', text: '#3D5F3A' },
  coral: { bg: '#FFEBE5', border: '#FF8A70', text: '#8C3F2D' },
  periwinkle: { bg: '#E5E7FA', border: '#818CF8', text: '#4338CA' },
  blush: { bg: '#FBE9EB', border: '#F472B6', text: '#9D174D' },
  seafoam: { bg: '#D9F6F1', border: '#4DD4AC', text: '#047857' },
  apricot: { bg: '#FEF0E1', border: '#FBBF24', text: '#92400E' },
  lilac: { bg: '#F3E8FF', border: '#C084FC', text: '#2563EB' },
  powder: { bg: '#E0F2FE', border: '#38BDF8', text: '#0369A1' },
  cream: { bg: '#FEF7E8', border: '#D9B573', text: '#78561B' },
};

export function getBookingFormEventColor(colorId?: string | null): { bg: string; border: string; text: string } | undefined {
  if (!colorId || colorId === 'default') return undefined;
  return BOOKING_FORM_EVENT_COLORS[colorId] || undefined;
}

const DYNAMIC_COLOR_PALETTE = [
  'bg-blue-100 text-blue-700 border-blue-200',
  'bg-blue-100 text-blue-700 border-blue-200',
  'bg-blue-100 text-blue-700 border-blue-200',
  'bg-amber-100 text-amber-700 border-amber-200',
  'bg-rose-100 text-rose-700 border-rose-200',
  'bg-cyan-100 text-cyan-700 border-cyan-200',
  'bg-emerald-100 text-emerald-700 border-emerald-200',
  'bg-fuchsia-100 text-fuchsia-700 border-fuchsia-200',
  'bg-sky-100 text-sky-700 border-sky-200',
  'bg-orange-100 text-orange-700 border-orange-200',
];

export function getEventTypeColorDynamic(type: string): string {
  if (EVENT_TYPE_COLORS[type]) return EVENT_TYPE_COLORS[type];
  let hash = 0;
  for (let i = 0; i < type.length; i++) {
    hash = type.charCodeAt(i) + ((hash << 5) - hash);
  }
  return DYNAMIC_COLOR_PALETTE[Math.abs(hash) % DYNAMIC_COLOR_PALETTE.length];
}

export const APPROVAL_STATUS_COLORS = {
  approved: 'bg-green-100 text-green-700 border-green-200',
  declined: 'bg-red-100 text-red-700 border-red-200',
  pending: 'bg-yellow-100 text-yellow-700 border-yellow-200'
};

/**
 * Average speed for drive time estimation (FALLBACK ONLY)
 * This is only used when Google Maps API data is not available.
 * Always prefer:
 * 1. Backend TravelInfo.travelTimeMinutes (from Google Maps Distance Matrix API)
 * 2. Frontend googleMapsDistanceService calculated duration
 */
export const AVG_SPEED_MPH = 30;

/**
 * Minimum gap between appointments to show time gap buttons
 */
export const MIN_GAP_MINUTES = 30;